export default __webpack_public_path__ + "static/media/Pradumna.f410ad04.pdf";